/* eslint-disable react/no-unescaped-entities */
import { SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Statistic,
  Typography,
  message
} from 'antd';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Chart } from 'react-google-charts';
import { NavLink } from 'react-router-dom';
import { CONFIG } from '../constants';
import EmpresaContext from '../context/empresa-context';
import UserContext from '../context/user-context';
import { instanceRef } from '../utils/axios';
import CustomDatePicker from './CustomDatePicker';
import ResponsiveContainer from './ResponsiveContainer';

const { RangePicker } = CustomDatePicker;
const { Option } = Select;
const { Title } = Typography;

const styles = {
  form: { maxWidth: 500 },
  item: { textAlign: 'left' },
  card: { marginBottom: 10, textAlign: 'left' }
};

// drillDownHandler(e, item, marcaList) {
//     const selected = e.chartWrapper.getChart().getSelection();
//     const selectedMarca = marcaList[selected[0].row + 1][0];
//     const newList = [['Estado', 'Total']];
//     if (selectedMarca !== 'TOTAL') {
//       Object.keys(item[selectedMarca]).forEach(e => {
//         if (e !== 'TOTAL')
//         newList.push([e, item[selectedMarca][e]]);
//       });
//     }
//     this.setState({ selectedMarcaList: newList });
//   }

//   const chartEvents = [
//     {
//       eventName: "select",
//       callback: (e) => this.drillDownHandler(e, item, marcaList)
//     }
//   ];

function Dashboard() {
  const { user } = useContext(UserContext);
  const { empresa } = useContext(EmpresaContext);
  const [form] = Form.useForm();
  const [filtroSucursal, setFiltroSucursal] = useState(false);
  const [loadingTotales, setLoadingTotales] = useState(false);
  const [loadingCantidades, setLoadingCantidades] = useState(false);
  const [loadingMontos, setLoadingMontos] = useState(false);
  const [loadingEstados, setLoadingEstados] = useState(false);
  const [loadingAseguradoras, setLoadingAseguradoras] = useState(false);
  const [totales, setTotales] = useState({
    cantidadCotizaciones: undefined,
    cantidadSolicitudes: undefined,
    cantidadPolizas: undefined,
    montoSolicitudes: undefined
  });

  const [cantidadData, setCantidadData] = useState();
  const [montoData, setMontoData] = useState();
  const [estadosData, setEstadosData] = useState();
  const [aseguradorasData, setAseguradorasData] = useState();
  const [sucursales, setSucursales] = useState([]);
  // const [geoData, setGeoData] = useState();

  const getTotales = async (params) => {
    setLoadingTotales(true);
    const totalesRsp = await instanceRef.instance.get('/dashboard/totales', {
      params
    });
    setTotales(totalesRsp?.data?.data);
    setLoadingTotales(false);
  };

  const getCantidades = async (params) => {
    setLoadingCantidades(true);
    const cantidadesRsp = await instanceRef.instance.get(
      '/dashboard/cantidades',
      {
        params
      }
    );

    const cantidades = cantidadesRsp?.data?.data;
    setCantidadData(cantidades.length > 1 ? cantidades : undefined);
    setLoadingCantidades(false);
  };

  const getMontos = async (params) => {
    setLoadingMontos(true);
    const montosRsp = await instanceRef.instance.get('/dashboard/montos', {
      params
    });
    const montos = montosRsp?.data?.data;
    setMontoData(montos.length > 1 ? montos : undefined);
    setLoadingMontos(false);
  };

  const getEstados = async (params) => {
    setLoadingEstados(true);
    const estadosRsp = await instanceRef.instance.get('/dashboard/estados', {
      params
    });
    const estados = estadosRsp?.data?.data;
    setEstadosData(estados.length > 1 ? estados : undefined);
    setLoadingEstados(false);
  };

  const getAseguradoras = async (params) => {
    setLoadingAseguradoras(true);
    const aseguradorasRsp = await instanceRef.instance.get(
      '/dashboard/aseguradoras',
      {
        params
      }
    );
    const aseguradoras = aseguradorasRsp?.data?.data;
    setAseguradorasData(aseguradoras.length > 1 ? aseguradoras : undefined);
    setLoadingAseguradoras(false);
  };

  const fetchData = async ({ periodo, sucursal, tipo }) => {
    let rango;
    if (periodo) {
      const desde = periodo[0].format('YYYY-MM-DD');
      const hasta = periodo[1].format('YYYY-MM-DD');
      rango = { desde, hasta };
    }

    const params = {
      filters: {
        ...(rango && { range: rango }),
        ...(sucursal && { sucursal }),
        ...(tipo && { tipo })
      }
    };

    getTotales(params);
    getCantidades(params);
    getMontos(params);
    getEstados(params);
    getAseguradoras(params);

    // const geoRsp = await instanceRef.instance.get('/dashboard/localizaciones', { params: { filters: { range, empresa: empresa.id } }});
    // const geoData = geoRsp?.data?.data;
    // setGeoData(geoData);
  };

  const loadSucursales = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get('sucursal');
      // console.log('response', response);
      if (response.data?.data) {
        setSucursales(response.data.data.rows);
      }
    } catch (error) {
      // error
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchData({ tipo: 'individual' });
      if (
        user['cognito:groups'] &&
        (user['cognito:groups'].includes('ADMIN') ||
          user['cognito:groups'].includes('ADMIN_EMPRESA'))
      ) {
        setFiltroSucursal(true);
        loadSucursales();
      }
    }
    if (
      user &&
      !user['cognito:groups'].includes('ADMIN') &&
      (user.email_verified === undefined || !user.email_verified)
    ) {
      verificarCuenta();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const onFinish = (values) => {
    fetchData(values);
  };

  const verificarCuenta = async () => {
    try {
      await instanceRef.instance.put(`perfil/verify/${user.sub}`);
      message.info('Se ha verificado la cuenta.');
    } catch (error) {
      message.error('No se ha verificado la cuenta.');
    }
  };

  return (
    <ResponsiveContainer size="large" style={{ paddingTop: 0 }}>
      <Card style={styles.card} title="Filtros">
        <Form
          initialValues={{ tipo: 'individual' }}
          scrollToFirstError
          form={form}
          layout="vertical"
          name="dashboard"
          autoComplete="off"
          onFinish={onFinish}
          style={styles.item}
        >
          <Row gutter={8} justify="start">
            <Col lg={12} md={12} xs={24}>
              <Form.Item label="Periodo" name="periodo">
                <RangePicker size="middle" format="DD-MM-YYYY" />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} xs={24}>
              <Form.Item label="Tipo" name="tipo">
                <Radio.Group>
                  <Radio.Button value="individual">Individual</Radio.Button>
                  <Radio.Button value="masivas">Por lote</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            {filtroSucursal &&
              !(user && user['cognito:groups'][0] === 'ADMIN_ASEGURADORA') && (
                <Col lg={12} md={12} xs={24}>
                  <Form.Item label="Sucursal" name="sucursal">
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%', maxWidth: 300 }}
                      optionFilterProp="children"
                      placeholder="Todas"
                      allowClear
                    >
                      {sucursales.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
            <Col xs={24}>
              <Form.Item noStyle>
                <Button
                  type="primary"
                  shape="round"
                  icon={<SearchOutlined />}
                  size="middle"
                  htmlType="submit"
                >
                  Buscar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <Card>
        <Card size="small">
          <Row gutter={[16, 0]} justify="center">
            <Col xs={24} sm={6} md={4}>
              <NavLink to="/cotizaciones">
                <Spin spinning={loadingTotales}>
                  <Statistic
                    title="Cotizaciones"
                    value={totales.cantidadCotizaciones}
                    groupSeparator="."
                    valueStyle={{
                      color: CONFIG.COLOR_PRIMARY,
                      fontSize: 30
                    }}
                  />
                </Spin>
              </NavLink>
            </Col>
            <Col xs={24} sm={6} md={4}>
              <NavLink to="/solicitudes">
                <Spin spinning={loadingTotales}>
                  <Statistic
                    title="Solicitudes"
                    value={totales.cantidadSolicitudes}
                    groupSeparator="."
                    valueStyle={{
                      color: CONFIG.COLOR_PRIMARY,
                      fontSize: 30
                    }}
                  />
                </Spin>
              </NavLink>
            </Col>
            <Col xs={24} sm={6} md={4}>
              <NavLink to="/polizas">
                <Spin spinning={loadingTotales}>
                  <Statistic
                    title="Pólizas"
                    value={totales.cantidadPolizas}
                    groupSeparator="."
                    valueStyle={{
                      color: CONFIG.COLOR_PRIMARY,
                      fontSize: 30
                    }}
                  />
                </Spin>
              </NavLink>
            </Col>
            <Col md={10} hidden>
              <Statistic
                title="Total emitido"
                value={totales.montoSolicitudes}
                loading={loadingTotales}
                groupSeparator="."
                valueStyle={{
                  color: CONFIG.COLOR_PRIMARY,
                  fontSize: 30
                }}
                suffix="Gs."
              />
            </Col>
          </Row>
        </Card>
        <br />
        <Row gutter={[24, 24]}>
          <Col md={12} xs={24}>
            <Card size="small">
              <Title level={4}>Cantidades por producto</Title>
              <Spin spinning={loadingCantidades && cantidadData !== undefined}>
                {cantidadData ? (
                  <Chart
                    width="100%"
                    height="300px"
                    chartType="ColumnChart"
                    data={cantidadData}
                    options={{
                      legend: 'top'
                    }}
                    // For tests
                    rootProps={{ 'data-testid': '1' }}
                  />
                ) : (
                  <Space direction="vertical">
                    <Spin spinning={loadingCantidades} />
                    <div style={{ height: 100 }}>No hay datos</div>
                  </Space>
                )}
              </Spin>
            </Card>
          </Col>
          <Col md={12} xs={24} hidden>
            <Card size="small">
              <Title level={4}>Montos por producto</Title>
              <Spin spinning={loadingMontos && montoData !== undefined}>
                {montoData ? (
                  <Chart
                    width="100%"
                    height="300px"
                    chartType="ColumnChart"
                    data={montoData}
                    options={{
                      legend: 'top'
                    }}
                    // For tests
                    rootProps={{ 'data-testid': '1' }}
                  />
                ) : (
                  <Space direction="vertical">
                    <Spin spinning={loadingMontos} />
                    <div style={{ height: 100 }}>No hay datos</div>
                  </Space>
                )}
              </Spin>
            </Card>
          </Col>
          {!empresa?.id_aseguradora &&
            !(user && user['cognito:groups'][0] === 'ADMIN_ASEGURADORA') && (
              <Col md={12} xs={24}>
                <Card size="small">
                  <Title level={4}>Pólizas por aseguradora</Title>
                  <Spin
                    spinning={
                      loadingAseguradoras && aseguradorasData !== undefined
                    }
                  >
                    {aseguradorasData ? (
                      <Chart
                        width="100%"
                        height="300px"
                        chartType="PieChart"
                        data={aseguradorasData}
                        options={{
                          pieHole: 0.4,
                          legend: 'top'
                        }}
                        rootProps={{ 'data-testid': '3' }}
                      />
                    ) : (
                      <Space direction="vertical">
                        <Spin spinning={loadingAseguradoras} />

                        <div style={{ height: 100 }}>No hay datos</div>
                      </Space>
                    )}
                  </Spin>
                </Card>
              </Col>
            )}
          <br />
          <Col md={12} xs={24}>
            <Card size="small">
              <Title level={4}>Solicitudes por estado</Title>
              <Spin spinning={loadingEstados && estadosData !== undefined}>
                {estadosData ? (
                  <Chart
                    width="100%"
                    height="300px"
                    chartType="PieChart"
                    data={estadosData}
                    options={{
                      legend: 'top'
                    }}
                    rootProps={{ 'data-testid': '2' }}
                  />
                ) : (
                  <Space direction="vertical">
                    <Spin spinning={loadingEstados} />

                    <div style={{ height: 100 }}>No hay datos</div>
                  </Space>
                )}
              </Spin>
            </Card>
          </Col>
        </Row>
        {/* <Chart
                        width={'100%'}
                        height={'300px'}
                        chartType="TreeMap"
                        data={geoData}
                        options={{
                            // minColor: '#f00',
                            // midColor: '#ddd',
                            // maxColor: '#0d0',
                            headerHeight: 15,
                            fontColor: 'black',
                            showScale: true,
                            title: 'Distribución geográfica de solicitudes',
                        }}
                        rootProps={{ 'data-testid': '4' }}
                    /> */}
      </Card>
    </ResponsiveContainer>
  );
}

export default Dashboard;
